<span class="relative flex flex-col w-full h-full p-8">
    <form [formGroup]="form">
        <div class="p-0 h-full overflow-hidden" mat-dialog-content>
            <ng-container>
                <div class="absolute top-0 right-0 pt-4 pr-4">
                    <button (click)="close()" mat-icon-button>
                        <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                    </button>
                </div>
            </ng-container>
            <ng-container>
                <div class="sm:flex xs:block w-100 items-center">
                    <div class="sm:flex-initial xs:block xs:max-w-100 sm:max-w-70pr">
                        <div class="text-2xl sm:text-4xl font-bold truncate basic-fuse-gray-color">{{ 'label_confirm' | translate }}</div>
                    </div>
                </div>
                <mat-divider class="my-4"></mat-divider>
                <div>
                    <p class="pb-4">{{ 'text_refetch_mortgage_eligibility_property_info' | translate }}</p>
                    <div class="pt-4">
                        <mat-checkbox [color]="'primary'" formControlName="refreshPropertyData">
                            {{ 'label_refetch_data' | translate }}
                        </mat-checkbox>
                        <mat-divider class="my-2"></mat-divider>
                        @if (form.get('refreshPropertyData').value) {
                        <div class="grid gap-1">
                            <mat-checkbox [color]="'primary'" formControlName="updatePropertyData">
                                {{ 'label_update_document_data' | translate }}
                            </mat-checkbox>
                            <mat-checkbox [color]="'primary'" formControlName="refreshPropertyInfoDocument">
                                {{ 'label_refetch_property_info_document' | translate }}
                            </mat-checkbox>
                            <mat-checkbox [color]="'primary'" formControlName="refreshPropertyEncumbranceInfoDocument">
                                {{ 'label_refetch_property_encumbrance_info_document' | translate }}
                            </mat-checkbox>
                            @if (!data.propertyInfoLastFetchedAt && !data.propertyEncumbranceInfoLastFetchedAt) {
                            <span class="font-semibold pt-2"> {{ 'info_no_property_info_exists_must_fetch' | translate }} </span>
                            }
                        </div>
                        } @if (!form.get('refreshPropertyData').value) {
                        <div>
                            <span class="pb-2 font-semibold">{{ 'info_reusing_last_data' | translate }}</span>
                            @if (data.propertyInfoLastFetchedAt) {
                            <div>
                                {{ 'label_property_info_last_fetched_at' | translate }}: {{ data.propertyInfoLastFetchedAt |
                                date:'dd.MM.yyyy HH:mm:ss' }}
                            </div>
                            } @if (data.propertyEncumbranceInfoLastFetchedAt) {
                            <div>
                                {{ 'label_property_encumbrance_info_last_fetched_at' | translate }}: {{
                                data.propertyEncumbranceInfoLastFetchedAt | date:'dd.MM.yyyy HH:mm:ss'}}
                            </div>
                            }
                        </div>
                        }
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="mt-4 flex justify-end" mat-dialog-actions>
            <button mat-stroked-button (click)="cancel()">{{ 'label_cancel' | translate }}</button>
            <button mat-flat-button (click)="submit()" color="primary" cdkFocusInitial>{{ 'label_confirm' | translate }}</button>
        </div>
    </form>
</span>
